import Vue from "vue/dist/vue.common";
import { isStaticFilter } from '../@types/Filters'

function ajaxUpdateProductFilters(filters) {
  const data = {
    action: 'update_product_filters',
    filters,
    nonce: TG.catalog_nonce
  }
  jQuery.post(
    TG.ajaxUrl,
    data
  )
}

export const Mutations = {
    ADD_FILTER(state, payload) {
        payload = payload.filter
        let exists = false;
        state.filters.forEach((term, i) => {
            if (payload.handle === term.handle) {
              exists = true
              state.filters[i] = payload
              if (payload.handle === 'category') {
                Mutations.REMOVE_FILTER(state, {
                  handle: 'parent'
                })
              }
            }
        })

        if (!exists) {
            payload.active = true
            state.filters.push(payload);
            Vue.set(state, 'searchUpdateNeeded', true)
        }
        
        ajaxUpdateProductFilters(state.filters)
        // setCookie('product_filters', JSON.stringify(state.filters), 7)
    },
    ADD_FILTER_QUIET(state, payload) {
      Mutations.ADD_FILTER(state, payload)
    },
    REMOVE_FILTER_QUIET(state, payload) {
      Mutations.REMOVE_FILTER(state, payload)
    },
    REMOVE_FILTER(state, payload) {
        Vue.set(state, 'filters', state.filters.filter(term => {
          if (payload.handle === 'category') {
            //Ensure that the parent filter is removed when the category filter is removed
            return !['parent', 'category'].includes(term.handle)
          } else {
            return !(payload.handle === term.handle)
          }                  
        } ))
        ajaxUpdateProductFilters(state.filters)
        // setCookie('product_filters', JSON.stringify(state.filters), 7)
        Vue.set(state, 'searchUpdateNeeded', true)
    },
    CLEAR_FILTERS(state) {
        Vue.set(state, 'filters', state.filters.filter(isStaticFilter));
        Vue.set(state, 'searchUpdateNeeded', false)
    },
    CLEAR_FILTERS_QUIET(state) {
      Mutations.CLEAR_FILTERS(state)
    },
    CLEAR_PRODUCTS : (state) => {
        Vue.set(state, 'isUpdatingProducts', true) 
        Vue.set(state, 'products', []);
    },
    UPDATE_PRODUCTS : (state, payload) => {
        Vue.set(state, 'products', payload.posts);
        Vue.set(state, 'current_page', payload.current_page)
        Vue.set(state, 'post_count', payload.post_count)
        Vue.set(state, 'max_num_pages', payload.max_num_pages)
        state.filters.forEach((term, i) => {
            Vue.set(state.filters[i], 'active', true)
        })            
    },
    SET_CATEGORIES : (state, payload) => {
        Vue.set(state, 'categories', payload);
    },
    SET_PRODUCTS : (state, payload) => {
        Vue.set(state, 'products', payload);
    },
    SET_ATTRIBUTES : (state, payload) => {
        Vue.set(state, 'attributes', payload);
    },
    ADD_ATTRIBUTE_TERMS : (state, payload) => {
        state.attributes.forEach((attribute, i) => {
            if (attribute.id === payload.attribute) { 
                Vue.set(state.attributes[i], 'terms', payload.terms)
            }
        })
    },
    updateProductTableData : (state, payload) => {
        state.elements.productTable = payload;
    },
    SET_COUNTDOWN_TIMER: (state, time) => {
        Vue.set(state, 'timePassed', time)
    },
    SET_COUNTDOWN_TIMER_STARTED: (state, started) => {
        Vue.set(state, 'updateCountdownStarted', started)
    }
}